import type { Dataset } from '@/types/entities'

/** Every seed/*.json is a Partial<Dataset> (owned by one account or 'shared').
 *  They're auto-discovered and merged so data agents can add files freely
 *  without collisions or edits here. Empty {} files contribute nothing. */
type PartialDataset = { [K in keyof Dataset]?: Dataset[K] }

const COLLECTIONS: (keyof Dataset)[] = [
  'accounts', 'tracks', 'contacts', 'opportunities', 'funds', 'properties',
  'financialPeriods', 'actionItems', 'workOrders', 'projects', 'events',
  'keyDates', 'ddReports', 'activities', 'tickets', 'files',
  'propertyInsights', 'accountInsights',
]

function emptyDataset(): Dataset {
  const d = {} as Dataset
  for (const k of COLLECTIONS) (d as unknown as Record<string, unknown[]>)[k] = []
  return d
}

const modules = import.meta.glob('./seed/*.json', { eager: true }) as Record<string, { default: PartialDataset }>

export const dataset: Dataset = (() => {
  const out = emptyDataset()
  for (const path of Object.keys(modules).sort()) {
    const part = modules[path]?.default
    if (!part) continue
    for (const k of COLLECTIONS) {
      const rows = part[k] as unknown[] | undefined
      if (Array.isArray(rows)) (out[k] as unknown[]).push(...rows)
    }
  }
  return out
})()
